{
  "message": "{{type}} not found"
}
